import {z} from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'
import {CardIconColors} from '@primer/react-brand'

export const PrimerComponentCardSchema = buildEntrySchemaFor('primerComponentCard', {
  fields: z.object({
    href: z.string(),
    heading: z.string(),
    description: RichTextSchema.optional(),
    ctaText: z.string().optional(),
    icon: z.string().optional(),
    iconColor: z.enum(CardIconColors).optional(),
    iconBackground: z.boolean().optional(),
    label: z.string().optional(),
  }),
})

export type PrimerComponentCard = z.infer<typeof PrimerComponentCardSchema>
